import axios from 'axios';
import { HEADERS, TOKEN } from '../constants';

const api = axios.create();

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN);

  if (token) {
    config.headers[HEADERS.NAMES.AUTHORIZATION] = `Bearer ${token}`;
  }

  config.headers[HEADERS.NAMES.CONTENT_TYPE] = HEADERS.VALUES.APPLICATION_JSON;

  return config;
});

export default api;
